import { getWalletStorageKeys, buildStorageValues } from './storageValues';
const getPaymentsWithId = _ref => {
  let {
    paymentInfo,
    walletId,
    walletStorageService,
    showSyncAlert,
    isManualSync,
    isLoggedIn
  } = _ref;
  if (!paymentInfo?.walletId) {
    // make sure we store walletId if not already
    paymentInfo.walletId = walletId;
  }
  if (showSyncAlert) {
    paymentInfo.interactions = {
      ...paymentInfo.interactions,
      syncAlert: {
        showAlert: true,
        success: true,
        isAuto: !isManualSync
      }
    };
  }
  if (walletStorageService) {
    const options = {
      walletId,
      paymentInfo: buildStorageValues({
        key: getWalletStorageKeys(),
        payload: paymentInfo
      }),
      isLoggedIn
    };
    walletStorageService.updateData(options);
  }
  return {
    paymentInfo
  };
};
export const createWalletId = async _ref2 => {
  let {
    walletStorageService,
    paymentInfo,
    isLoggedIn
  } = _ref2;
  // Create a new Wallet Id with current payment info
  const currentPaymentInfo = buildStorageValues({
    key: getWalletStorageKeys(),
    payload: paymentInfo
  });
  const options = {
    paymentInfo: currentPaymentInfo
  };
  const response = await walletStorageService.setData(options, isLoggedIn);
  if (response?.id) {
    walletStorageService.setWalletId(response.id);
  }
  return response?.id;
};
export const syncWithWalletStorage = async _ref3 => {
  let {
    action,
    walletStorageService,
    paymentInfo,
    consumerid,
    isManualSync,
    isLoggedIn
  } = _ref3;
  const walletId = paymentInfo?.walletId;
  if (walletStorageService) {
    if (action === 'get') {
      let paymentsFromStorage;
      try {
        // If consumerid is present use that to retrieve wallet data
        if (consumerid) {
          paymentsFromStorage = await walletStorageService.getData({
            consumerid
          });
        }
      } catch (error) {
        paymentsFromStorage = {};
      }

      //  else use walletId for retrieval, lastly if no wallet id return statusCode 404
      if (!consumerid || !Object.keys(paymentsFromStorage).length) {
        paymentsFromStorage = walletId ? await walletStorageService.getData({
          walletId
        }) : {
          statusCode: 404
        };
      }
      if (!consumerid && paymentsFromStorage?.statusCode === 404) {
        // The Wallet Id in Local Storage isn't valid
        // delete it from paymentInfo and repeat the process
        // so we can get a valid id from Wallet Central or create a new id
        delete paymentInfo.walletId;
        const syncData = await walletStorageService.syncId();
        let walletCentralId = syncData?.id;
        if (walletCentralId === walletId) {
          // if Wallet Central also has the invalid id or created by WalletCentral iframe,
          // reset and create an id from WalletStorage API
          walletCentralId = null;
        }

        // recurse syncWithWalletStorage if Wallet Central has an id stored
        if (walletCentralId) {
          return syncWithWalletStorage({
            action: 'get',
            walletStorageService,
            paymentInfo: getPaymentsWithId({
              paymentInfo,
              walletId: walletCentralId
            }).paymentInfo,
            isLoggedIn
          });
        }
        return {
          paymentInfo
        };
      }

      // compare to see which has the latest info
      const lastUpdatedCache = walletStorageService.getWalletLastUpdated();

      // if Wallet was updated from other sites/apps or manually imported with a different id:
      if (isManualSync || (paymentsFromStorage?.paymentInfo?.lastUpdated || 0) > (lastUpdatedCache || 0)) {
        if (isManualSync) {
          // if manual sync, load wallet central iframe and set id there too
          walletStorageService.postId(walletId);
        }
        return getPaymentsWithId({
          paymentInfo: paymentsFromStorage?.paymentInfo,
          walletId,
          showSyncAlert: true,
          isManualSync,
          isLoggedIn
        });
      }

      // return data from Wallet Storage
      return paymentsFromStorage;
    }
    if (action === 'update') {
      const options = {
        walletId,
        paymentInfo: buildStorageValues({
          key: getWalletStorageKeys(),
          payload: paymentInfo
        }),
        isLoggedIn
      };
      if (consumerid) {
        options.consumerid = consumerid;
      }
      return walletStorageService.updateData(options);
    }
  }
  return {
    paymentInfo
  };
};